<template>
  <div class="product-detail-page">
    <div class="container">
      <!-- 返回按钮 -->
      <el-button
        icon="el-icon-arrow-left"
        @click="$router.back()"
        class="back-btn"
      >
        返回产品列表
      </el-button>

      <!-- 产品详情：响应式布局 -->
      <el-row :gutter="20" v-if="product">
        <!-- 产品图片：移动端占满，PC 占 1/2 -->
        <el-col :xs="24" :md="12">
          <img
            :src="product.cover"
            class="img-fluid product-detail-cover"
            alt="产品详情图"
          />
        </el-col>
        <!-- 产品信息：移动端占满，PC 占 1/2 -->
        <el-col :xs="24" :md="12">
          <div class="product-detail-info">
            <h1>{{ product.name }}</h1>
            <div class="price">¥{{ product.price }}</div>
            <div class="divider"></div>
            <div class="brief">{{ product.brief }}</div>
            <!-- 产品详情 HTML -->
            <div class="detail-content" v-html="product.detail"></div>
            <el-button type="primary" size="large" class="contact-btn">
              咨询产品
            </el-button>
          </div>
        </el-col>
      </el-row>

      <!-- 产品不存在时的提示 -->
      <div v-else class="empty-tip">
        <el-empty description="未找到该产品"></el-empty>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useProductStore } from "@/stores";
import { useRoute } from "vue-router";

const route = useRoute();
const productStore = useProductStore();
const product = ref(null);

// 页面加载时获取产品详情
onMounted(() => {
  const productId = route.params.id;
  product.value = productStore.getProductById(productId);
});
</script>

<style scoped>
.product-detail-page {
  padding: 2rem 0;
}

.back-btn {
  margin-bottom: 2rem;
}

.product-detail-cover {
  border-radius: 8px;
}

.product-detail-info h1 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 1rem;
}

.product-detail-info .price {
  font-size: 1.5rem;
  color: #e6a23c;
  font-weight: bold;
  margin-bottom: 1rem;
}

.product-detail-info .divider {
  width: 50px;
  height: 2px;
  background-color: #1989fa;
  margin-bottom: 1rem;
}

.product-detail-info .brief {
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.8;
}

.detail-content {
  margin-bottom: 2rem;
  color: #555;
  line-height: 1.8;
}

.detail-content h3 {
  font-size: 1.2rem;
  margin: 1.5rem 0 1rem;
  color: #333;
}

.detail-content ul {
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}

.contact-btn {
  width: 100%;
  max-width: 300px;
}

.empty-tip {
  text-align: center;
  padding: 4rem 0;
}

/* 移动端适配 */
</style>
